/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PopupSettingDto } from '../../models/popup-setting-dto';

export interface PopupControllerGetPopupSettingByType$Params {

/**
 * 팝업 타입
 */
  type: 'NORMAL' | 'ADVERTISE';
}

export function popupControllerGetPopupSettingByType(http: HttpClient, rootUrl: string, params: PopupControllerGetPopupSettingByType$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupSettingDto>> {
  const rb = new RequestBuilder(rootUrl, popupControllerGetPopupSettingByType.PATH, 'get');
  if (params) {
    rb.path('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PopupSettingDto>;
    })
  );
}

popupControllerGetPopupSettingByType.PATH = '/api/popups/setting/{type}';
